<template>
  <div class="custSlider">
    <hooper :centerMode="true" pagination="no">
      <slide v-for="(img, m) in imgs" :key="'image' + m" :index="m">
        <img
          :src="img"
          style="max-height:170px;max-width:100%;"
          @click="()=>{
              if(!cart.map(x=>x.sku).includes(product.sku)) {
                addToCart(product)
              }
            }"
        > 
      </slide>
      <hooper-navigation slot="hooper-addons"></hooper-navigation>
    </hooper>
  </div>
</template>

<script>
import { Hooper, Slide, Pagination as HooperPagination,
  Navigation as HooperNavigation } from 'hooper';
import 'hooper/dist/hooper.css';
export default {
  components: {
    Hooper,
    Slide,
    HooperPagination,
    HooperNavigation
  },
  props:['product'],
  computed:{
    imgs(){
      return this.product.images.map(x=>x.url)
    },
    cart(){
      return this.$store.getters.cart
    },
  },
  methods: {
    addToCart(product) {
      this.$store.dispatch('addToCart', product)
    },

  }
}
</script>

<style>
.custSlider * {
  direction: ltr !important;
}
</style>